export const idlFactory = ({ IDL }) => {
  const VoteType = IDL.Variant({
    'No' : IDL.Null,
    'Yes' : IDL.Null,
    'Abstain' : IDL.Null,
  });
  const TalkingPointId = IDL.Text;
  const UserTalkingPoint = IDL.Record({
    'id' : TalkingPointId,
    'title' : IDL.Text,
    'vote' : IDL.Text,
    'description' : IDL.Text,
  });
  const Voting = IDL.Service({
    'getMyVote' : IDL.Func([IDL.Text], [IDL.Opt(VoteType)], ['query']),
    'getTalkingPoints' : IDL.Func([], [IDL.Vec(UserTalkingPoint)], ['query']),
    'vote' : IDL.Func([IDL.Text, VoteType], [], []),
  });
  return Voting;
};
export const init = ({ IDL }) => { return []; };
